<template>
    <div class="w-full mx-auto px-1 overflow-hidden">
        <div class="pt-8 pb-6 flex justify-between">
            <p class="font-medium text-sm text-costeaBlack">Listado de componentes</p>

            <div class="flex">
                <button @click="ventanaFlotante = true"
                    class="flex bg-costeaBtn2 hover:bg-costeaBtn2Hover cursor-pointer items-center px-4 py-2 text-costeaPrimary text-t12 rounded-md">
                    <span>Agregar componente</span>
                    <i class="ri-add-circle-fill ml-2 text-t14"></i>
                </button>

                <button @click="this.getDataForExcel" v-if="(this.rol_usuario === '1' || this.rol_usuario === '2') &&
                    !this.generatingExcel && !this.downloadExcel"
                    class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel">
                    <i class="ri-file-excel-2-fill text-xl"></i>
                    <span
                        class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">
                        Exportar a Excel
                    </span>
                </button>
                <p v-if="this.generatingExcel"
                    class="flex justify-center items-center bg-costeaDarkGreen text-white font-costea text-sm w-auto h-10 ml-3 transition cursor-pointer rounded-md hover:bg-green-600 relative buttonExcel">
                    <span class="text-white px-2 py-1 text-xs rounded-full w-auto">
                        Generando...
                    </span>
                </p>
                <vue-excel-xlsx v-if="this.downloadExcel"
                    class="flex justify-center items-center bg-costeaPrimary text-white font-costea text-sm w-12 h-10 ml-3 transition cursor-pointer rounded-md hover:bg-costeaHover relative buttonExcel"
                    :data="this.columnasExcel[0]" :columns="this.columnasExcel[1]" :file-name="'Materia Prima'"
                    :file-type="'xlsx'" :sheet-name="'Materia prima'" @click="this.getDataForExcel">
                    <i class="ri-download-cloud-2-line text-xl"></i>
                    <span
                        class="bg-gray-600 text-white px-2 py-1 text-xs rounded-full absolute w-28 -bottom-12 right-0 opacity-0 buttonExcelToolTip">Descargar
                        Excel</span>
                </vue-excel-xlsx>
            </div>

        </div>
        <div class="w-full overflow-x-auto">
            <table class="w-full overflow-x-auto">
                <thead class="font-costea text-xs border-b-2  pb-3 h-10 text-left">
                    <th></th>
                    <th><span class="mr-8 w-40 relative block text-costeaDarkGray font-medium">Nombre</span></th>
                    <th><span class="mr-4 w-24 relative block text-costeaDarkGray font-medium">Referencia</span></th>
                    <th><span class="mr-4 w-28 relative block text-costeaDarkGray font-medium">Tipo de materia
                            prima</span></th>
                    <th><span class="w-28 relative block text-costeaDarkGray font-medium">Costo materia prima</span>
                    </th>
                    <th><span class="w-20 relative block text-costeaDarkGray font-medium">Cantidad</span></th>
                    <th><span class="w-20 relative block text-costeaDarkGray font-medium">Unidad</span></th>
                    <th><span class="w-36 relative block text-costeaDarkGray font-medium">Costo total unitario</span>
                    </th>
                    <th><span class="w-14 relative block text-costeaDarkGray font-medium">Remover</span></th>
                </thead>
                <tr class="font-costea text-t12 border-b-2 pb-3 h-14" v-for="componentes in this.dataComponentesProducto"
                    :key="componentes.index">
                    <td>
                        <div class="mr-3 w-7 h-7 flex justify-center items-center">
                            <img class="w-full h-auto rounded-md" :src="showImage(componentes.picture)"
                                alt="Imagen de componente">
                        </div>
                    </td>
                    <td>
                        <span class="cursor-pointer text-costeaGray">{{ componentes.name }}</span>
                    </td>
                    <td><span class="cursor-pointer text-costeaGray">{{ componentes.referencia }}</span></td>
                    <td><span class="cursor-pointer text-costeaGray">{{ componentes.tipo_materia_prima }}</span></td>
                    <td><span class="cursor-pointer text-costeaGray">$
                            {{ (componentes.tipo_materia_prima === 'Nacional' ?
                                interNegativeNumberFormat(componentes.costo_unitario) :
                                interNegativeNumberFormat(componentes.costo_unitario * componentes.tasa_de_cambio)) }}</span>
                    </td>
                    <td><span class="cursor-pointer text-costeaGray">{{ componentes.cantidadVinculada }}</span></td>
                    <td><span class="cursor-pointer text-costeaGray">{{ componentes.unidad_de_medida }}</span></td>
                    <td><span class="cursor-pointer text-costeaGray">$ {{
                        interNegativeNumberFormat(componentes.tipo_materia_prima === 'Nacional' ?
                            componentes.costo_unitario * componentes.cantidadVinculada : (componentes.costo_unitario *
                                componentes.tasa_de_cambio) * componentes.cantidadVinculada)
                    }}</span></td>
                    <td>
                        <button @click="deleteComponente(componentes.componentes_id)"
                            class="text-xs mx-2 cursor-pointer bg-costeaContainer text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaSalmon rounded-full w-5 h-5 flex justify-center items-center"><i
                                class="ri-close-fill"></i></button>
                    </td>
                </tr>
            </table>
        </div>


        <!--Ventana emergente añadir componente-->
        <transition name="page">
            <!-- <div class="absolute w-full h-full left-0 top-0 addmodal z-200 " v-if="ventanaFlotante"> -->
            <div class="addmodal fixed w-full h-screen z-20 top-0 left-0 flex justify-center items-start overflow-auto"
                v-if="ventanaFlotante">

                <div class="flex justify-center items-center w-full h-full">
                    <div
                        class="card z-50 w-11/12 md:w-10/12 lg:w-8/12 h-auto rounded-md overflow-hidden flex flex-col items-center justify-end bg-white">
                        <div class="flex justify-between items-end w-11/12 pt-6 pb-2 border-b-2">
                            <div>
                                <h3 class="font-costea text-t14 font-medium text-costeaBlack mb-2">
                                    Asociar componente al producto
                                </h3>

                            </div>
                        </div>


                        <div
                            class="flex flex-row bg-white items-center justify-end px-4 w-11/12  h-10 box-border text-costeaGray text-t14 rounded-md">

                            <div class="mt-4 flex justify-center items-center bg-gray-100 py-2 px-3">
                                <i class="ri-search-line mx-2"></i>
                                <input type="text" name="searchInput" id="searchInput" v-model="searchInput"
                                    class="w-40 outline-none pr-2 bg-gray-100" placeholder="Buscar Componentes">
                            </div>

                        </div>


                        <div class="w-11/12">
                            <div class="w-full mt-4 max-h-56 overflow-auto">
                                <table class="w-full">
                                    <thead class="font-costea text-t12 border-b-2 pb-3 h-10 text-left">
                                        <th></th>
                                        <th></th>
                                        <th><span class="mr-8 text-costeaDarkGray font-medium">Nombre</span></th>
                                        <th><span class="mr-4 text-costeaDarkGray font-medium">Referencia</span></th>
                                        <th><span class="mr-4 text-costeaDarkGray font-medium">Tipo de materia
                                                prima</span></th>
                                        <th><span class="mr-4 text-costeaDarkGray font-medium">Costo materia
                                                prima</span></th>
                                        <th><span class="mr-4 text-costeaDarkGray font-medium">Unidades</span></th>
                                        <th><span class="mr-4 text-costeaDarkGray font-medium">Costo total
                                                unitario</span></th>
                                    </thead>
                                    <tr class="font-costea text-t12 border-b-2 pb-3 h-14"
                                        v-for="(componentes, index) in this.displayedComponents" :key="index">

                                        <td><input v-model="seleccionComponentes" @change="printComp"
                                                :value="componentes.id" type="checkbox"
                                                :class="{ 'w-4 h-4 rounded-sm border-2 mr-2': true}" 
                                                :checked="tieneValor(componentes.id)">
                                        </td>
                                        <td>
                                            <div class="ml-2 w-8 h-auto flex justify-center items-center">
                                                <img class="w-full h-full rounded-md" :src="showImage(componentes.picture)"
                                                    alt="Imagen de componente">
                                            </div>
                                        </td>
                                        <td><span class="cursor-pointer text-costeaGray">{{ componentes.name }}</span>
                                        </td>
                                        <td><span class="cursor-pointer text-costeaGray">{{ componentes.referencia
                                        }}</span>
                                        </td>
                                        <td><span class="cursor-pointer text-costeaGray">{{
                                            componentes.tipo_materia_prima
                                        }}</span>
                                        </td>
                                        <td><span class="cursor-pointer text-costeaGray">$
                                                {{ (componentes.tipo_materia_prima === 'Nacional' ?
                                                    interNegativeNumberFormat(componentes.costo_unitario) :
                                                    interNegativeNumberFormat(componentes.costo_unitario *
                                                        componentes.tasa_de_cambio)) }}</span></td>
                                        <td><span class="cursor-pointer text-costeaGray"><input @change="testPrint"
                                                    v-model="dataCantidadVinculada[componentes.id]"
                                                    class="bg-costeaContainer rounded-sm py-2  text-center px-1 text-t14 w-14"
                                                    type="number" min="0.01" max="9999" step="0.01" /></span></td>
                                        <td><span class="cursor-pointer text-costeaGray">$
                                                {{ dataCantidadVinculada[componentes.id] ?
                                                    interNegativeNumberFormat(componentes.costo_unitario *
                                                        dataCantidadVinculada[componentes.id]) : 0
                                                }}</span></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="flex flex-row flex-nowrap items-center justify-end w-full mr-8 my-5 ">
                            <span class="font-costea text-t12 text-costeaGray">Seleccionados <b class="text-costeaBlack">{{
                                seleccionComponentes.length }}</b></span>
                        </div>

                        <div class="flex justify-end w-full border-t-2">
                            <div class="flex flex-col justify-center items-end w-5/12 m-1">
                                <div class="mt-4 mb-4 mr-4 text-t12 flex justify-end">
                                    <button @click="ventanaFlotante = false"
                                        class="bg-costeaBtn2 px-7 py-2 rounded-md text-costeaPrimary mr-2 hover:bg-costeaBtn2Hover">Cancelar</button>
                                    <button @click="setComponentes"
                                        :class="'px-7 py-2 rounded-md text-white ml-2 hover:bg-costeaHover ' + buttonBg">{{
                                            buttonText
                                        }}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </transition>
        <!---->



    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
// import ProductService from '@/services/productoService.js'


export default {
    name: "MateriaPrima",
    props: ['dataProducto', 'dataCategory', 'manoObra', 'cif', 'costoTotal', 'precioVentaActual', 'calcCostoTotal', 'dataComponentes', 'dataComponentesProducto'],
    data: function () {
        return {
            // nums: [1, 2, 3, 4, 5, 6],
            seleccionComponentes: [],
            compTest: [1, 3, 4],
            componentesproducto: this.dataComponentesProducto,
            componentes: [],
            ventanaFlotante: false,
            producto: [],
            secretWord: localStorage.getItem("secret-word"),
            cantidadComponentes: [],
            dataCantidadVinculada: [],
            buttonText: "Asociar",
            buttonBg: "bg-costeaPrimary",
            searchInput: "",
            downloadExcel: false,
            columnasExcel: [],
            generatingExcel: false,
            showDownload: false,
            rol_usuario: localStorage.getItem("rol_usuario"),
        };
    },
    async mounted() {
        const response = await axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}componentes`);
        this.componentes = response.data;
        this.componentesproducto = this.dataComponentesProducto
        for (const i of this.dataComponentesProducto) {
                this.dataCantidadVinculada[i.componentes_id] = i.cantidadVinculada

            }
    },
    computed: {

        ...mapState(["costea"]),
       
        printComp() {
            return console.log(JSON.stringify(this.seleccionComponentes));
        },
        displayedComponents() {
            // return this.componentesproducto
            if (this.searchInput === "") {
                return this.componentes;
            } else {
                return this.findsearchInput;
            }
            // return []
        },
        findsearchInput() {
            let components = '';
            let propertysToSearch = ['name', 'referencia', 'tipo_materia_prima'];
            let searchInput = this.searchInput.toLowerCase();
            components = this.componentes.filter(function (component) {
                let found = false;
                propertysToSearch.forEach(function (property) {
                    if (component[property].toLowerCase().indexOf(searchInput) > -1) {
                        found = true;
                    }
                });
                return found;
            });

            return components;

        },
        
    },
    methods: {
        tieneValor(componenteId) {
        return !!this.dataCantidadVinculada[componenteId];
    },
        JsonToXlsx() {
            let componentes = this.dataComponentesProducto;
            let componentesJson = [];
            console.log("Componentes", componentes)
            componentes.forEach((component, i) => {
                let componente = {
                    "Referencia": i === 0 ? this.dataProducto.referencia : "",
                    "Descripción/Nombre": i === 0 ? this.dataProducto.nombre : "",
                    "Código Barras": i === 0 ? this.dataProducto.codigo_barras : "",
                    "Categoria": i === 0 ? this.dataCategory.name : "",
                    "Referencia Componente": component.referencia,
                    "Nombre Componente": component.name,
                    "Tipo de materia prima": component.tipo_materia_prima,
                    "Costo de Materia Prima": (component.tipo_materia_prima === 'Nacional' ? (component.costo_unitario * 1) : ((component.costo_unitario * component.tasa_de_cambio) * 1)),
                    "Cantidad": (component.cantidadVinculada * 1),
                    "Unidad de medida": component.unidad_de_medida,
                    "Costo Total Materiales": (component.tipo_materia_prima === 'Nacional' ? ((component.costo_unitario * component.cantidadVinculada) * 1) : (((component.costo_unitario * component.tasa_de_cambio) * component.cantidadVinculada) * 1)),
                    "Costo Mano de Obra": i === 0 ? (this.manoObra * 1) : "",
                    "CIF": i === 0 ? (this.cif * 1) : "",
                    "Costo Total": i === 0 ? (this.dataProducto.costo_total * 1) : "",
                    "Precio de Venta Actual": i === 0 ? (this.dataProducto.precio_venta_actual * 1) : "",
                    "Utilidad": i === 0 ? (this.precioVentaActual - this.dataProducto.costo_total * 1) : "",
                };
                if (localStorage.getItem('rol_usuario') === '2') {
                    let componentesOperario = Object.assign({}, componente)
                    delete componentesOperario.CIF;
                    delete componentesOperario['Costo Mano de Obra']
                    delete componentesOperario['Costo Total']
                    delete componentesOperario['Precio de Venta Actual']
                    delete componentesOperario.Utilidad
                    componentesJson.push(componentesOperario);
                } else {
                    componentesJson.push(componente)
                }
            })

            let columns = [
                {
                    label: "Referencia",
                    field: "Referencia",
                },
                {
                    label: "Descripción/Nombre",
                    field: "Descripción/Nombre",
                },
                {
                    label: "Código Barras",
                    field: "Código Barras",
                },
                {
                    label: "Categoria",
                    field: "Categoria",
                },
                {
                    label: "Referencia Componente",
                    field: "Referencia Componente",
                },
                {
                    label: "Nombre Componente",
                    field: "Nombre Componente",
                },
                {
                    label: "Tipo de materia prima",
                    field: "Tipo de materia prima",
                },
                {
                    label: "Costo de Materia Prima",
                    field: "Costo de Materia Prima",
                },
                {
                    label: "Cantidad",
                    field: "Cantidad",
                },
                {
                    label: "Unidad de medida",
                    field: "Unidad de medida",
                },
                {
                    label: "Costo Total Materiales",
                    field: "Costo Total Materiales",
                },
                {
                    label: "Costo Mano de Obra",
                    field: "Costo Mano de Obra",
                },
                {
                    label: "CIF",
                    field: "CIF",
                },
                {
                    label: "Costo Total",
                    field: "Costo Total",
                },
                {
                    label: "Precio de Venta Actual",
                    field: "Precio de Venta Actual",
                },
                {
                    label: "Utilidad",
                    field: "Utilidad",
                },
            ]
            this.generatingExcel = false;
            this.downloadExcel = true
            this.columnasExcel = [componentesJson, columns];
        },
        async getDataForExcel() {
            this.downloadExcel = false
            this.generatingExcel = true;
            this.JsonToXlsx()
        },
        // formatNumbers(number){
        //     let num = number;
        //     num = parseFloat(num)
        //     num = num.toLocaleString('es-CO')
        //     return num;
        // },
        interNumberFormat(number) {
            let interNF = new Intl.NumberFormat('es-CO');
            let numberDecimals = parseFloat(number)
            numberDecimals = numberDecimals.toFixed(2)
            return isNaN(number) ? number : interNF.format(numberDecimals)
        },
        interNegativeNumberFormat(number) {
            let interNF = new Intl.NumberFormat('es-CO');
            let numberDecimals = parseFloat(number)
            numberDecimals = numberDecimals.toFixed(2)
            return isNaN(number) ? "0,00" : interNF.format(numberDecimals)
        },
        testPrint() {
            return console.log(this.dataCantidadVinculada);
        },
        deleteComponente(id) {
            let components = [];
            let quantity = [];
            console.log(id);
            // for (var i = 0; i < this.dataProducto.componentes.length; i++) {
            //     if (this.dataProducto.componentes[i].componentes_id != id) {
            //         components.push(this.producto[i].componentes_id);
            //         quantity.push(this.producto[i].cantidadVinculada);
            //     }
            //     else {
            //         continue;
            //     }
            // }
            for (const i of this.dataComponentesProducto) {
                if (!components.some(e => e === i.componentes_id) && i.componentes_id != id ) {
                    components.push(i.componentes_id)
                    quantity.push(i.cantidadVinculada)
                }

            }
            this.dataCantidadVinculada[id] = undefined

            // components.push(id)
            // quantity.push(0)
            axios.post(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}producto/componente-add/${this.$route.params.id}`, { componentes_id: components, cantidadVinculada: quantity })
                .then(() => {
                    setTimeout(() => {
                        this.componentesproducto = [];
                        this.$emit("reloadData", true);
                    }, 100);
                    setTimeout(() => {
                        this.getComponentesProducto();
                    }, 100);
                }).catch(error => { console.log(error); });
        },
        showImage(imagen) {
            if (imagen != null) {
                return this.costea.protocol + this.secretWord + ".backend.costea.com.co/" + imagen;
            }
            else {
                return "/img/perfilCostea.png";
            }
        },
        getComponentesProducto() {

            // ProductService.getComponentesProducto(this.$route.params.id)
            //     .then(({ producto, componentes }) => {
            //         this.producto = producto;
            //         this.componentes = componentes;
            //         this.filterComponents();  // Asegúrate de que este método esté definido en este componente
            //     })
            //     .catch(error => console.log(error));

            // axios.get(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}producto-view/${this.$route.params.id}`)
            //     .then(response => {
            //         this.producto = response.data.data.componentes;
            //         // console.log(response.data.data)
            //         axios.get(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}componentes`)
            //             .then(response => {
            //                 this.componentes = response.data;
            //                 // console.log(this.componentes);
            //                 this.filterComponents();
            //             }).catch(error => console.log(error));
            //     }).catch(error => {
            //         console.log(error);
            //     });
        },
        filterComponents() {
            for (var i = 0; i < this.componentes.length; i++) {
                for (var j = 0; j < this.dataProducto.componentes.length; j++) {
                    if (this.componentes[i].id === this.dataProducto.componentes[j].componentes_id) {
                        let componente = this.componentes[i];
                        componente.cantidadVinculada = this.dataProducto.componentes[j].cantidadVinculada;
                        this.componentesproducto.push(componente);
                        // console.log(this.componentesproducto);
                    }
                }
            }
        },
        setComponentes() {
          
            let components = []
            let cantidades = [];

            for (const i of this.dataComponentesProducto) {
                if (!components.some(e => e === i.componentes_id)) {
                    components.push(i.componentes_id)
                    cantidades.push(i.cantidadVinculada)
                }

            }
            for (let i = 0; i < this.dataCantidadVinculada.length; i++) {
                if (parseFloat(this.dataCantidadVinculada[i]) > 0 && this.dataCantidadVinculada[i] != undefined) {

                // if (parseInt(this.dataCantidadVinculada[i]) > 0 && this.dataCantidadVinculada[i] != undefined) {
                   
                    components.push(i)
                    cantidades.push(this.dataCantidadVinculada[i])
                    this.dataComponentesProducto.push(this.componentes.find(e => e.componentes_id = i))
                }
            }
            
            console.log({ componentes_id: components, cantidadVinculada: cantidades });


            axios.post(`${this.costea.protocol}${localStorage.getItem("secret-word")}${this.costea.baseURL}producto/componente-add/${this.$route.params.id}`, { componentes_id: components, cantidadVinculada: cantidades })
                .then(() => {
                    setTimeout(() => {
                        this.buttonText = "Listo!";
                        this.buttonBg = "bg-costeaDarkGreen";
                    }, 100);
                    setTimeout(() => {
                        this.closeModal();
                        this.seleccionComponentes = []
                    }, 1000);
                    setTimeout(() => {
                        this.buttonText = "Asociar";
                        this.buttonBg = "bg-costeaPrimary";
                    }, 3000);
                }).catch(error => console.log(error));
        },
        // onProcess() {
        //     this.buttonText = "Asociando...";
        // },
        closeModal() {
            this.ventanaFlotante = false;
            this.$emit("reloadData", true);
            this.componentesproducto = [];
            this.getComponentesProducto();
        },
        paginate(obj) {
            let page = this.page;
            let perPage = this.elementsPerPage;
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return obj.slice(from, to);
        },
    },
    created() {
        this.getComponentesProducto();
    },
}
</script>

<style>
th {
    height: 40px;
}

td {
    margin: 10px 0px;
}</style>